import { LoaderActions } from '@store/loaders'
import {
  PROJECTS_LIMIT_REACHED,
  upgradeToast,
} from '@store/reducers/limitReached'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { NestClient } from '@/nest'
import {
  type DashboardActions,
  InternalProjectActions as Internal,
} from '../../actions'
import { parseNestError } from '../../utils'

export function* moveTo({
  payload,
}: ReturnType<typeof DashboardActions.projects.moveToWorkspace>) {
  const { id, folderId, workspaceId } = payload

  yield put(LoaderActions.set(id))

  sendGtmEvent(GtmTriggerName.PROJECT_MOVE)

  try {
    yield call(NestClient.projects.moveTo, { ids: [id] }, workspaceId, folderId)
    yield put(Internal.move(payload))
  } catch (e) {
    const message = parseNestError(e)

    if (message === PROJECTS_LIMIT_REACHED) {
      yield* upgradeToast(message)

      return
    }

    yield put(ErrorNotification(message))
  } finally {
    yield put(LoaderActions.unset(id))
  }
}
